import { type IShallowRentalIntake } from "@/interfaces/api/shallow-rental-intake.interface"
import { ShallowRentalMutation } from "@/models/shallow-rental-mutation"

export class ShallowRentalIntake extends ShallowRentalMutation implements IShallowRentalIntake {
  public static className = "ShallowRentalIntake" // Used for socket communication.
  public static verboseName = "Inhuur (ondiep)"

  rentalIntakeItem: number

  associatedRentalDispense?: number

  constructor(rentalIntake: IShallowRentalIntake) {
    super(rentalIntake)
    this.rentalIntakeItem = rentalIntake.rentalIntakeItem
    this.associatedRentalDispense = rentalIntake.associatedRentalDispense
  }
}
